
<div id="sbamWrapper" class="no-title-layout" [ngStyle]="themeManager.getUnderlayStyle(true)" style="width:100%">

  <ng-container *ngIf="state=='LOADING'">
    <div class="dashboard-tile" style="width:300px; height: auto; margin:auto;">
      <app-grid-spinner #spinner></app-grid-spinner>
      <div class="tile-header">
        <div class="tile-header-title">
          Loading
        </div>
      </div>
      <div class="tile-content">
        <div style="height:300px;">
          <img mat-card-image class="tile-logo" src="{{themeManager.getStackedLogo()}}" >
          <div style="padding:50px 20px 0 20px; text-align:center;">Accessing the Assessments Platform</div>
          <div style="padding:5px 20px 0 20px; text-align:center;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
        </div>
      </div>
    </div>
  </ng-container>

  <cw-ci-assessment-work class="overflow-visible" *ngIf="state=='ASSESSMENT'" (stateChange)="onStateChange($event)" [account]='account' [accountAssessment]='selectedAssessment'></cw-ci-assessment-work>

  <ng-container *ngIf="state=='COMPLETEDASSESSMENT'">
    <div class="dashboard-tile mat-elevation-z4" style="width:400px; height:500px; margin: auto;">
      <div class="tile-header">
        <div class="tile-header-title">Assessment Completed</div>
      </div>
      <div class="tile-content" style="text-align:center">
        <h2 style="padding-top:50px">THANK YOU</h2>
        <div style="padding:0 20px 20px 20px;">You have completed your assessment. Please click the button below to access
          your results.</div>
        <button mat-raised-button color="primary" (click)="state='REPORT'">Show My Results</button>
      </div>
    </div>
  </ng-container>
  
  <cw-ci-assessment-report *ngIf="state=='REPORT'" (stateChange)="onStateChange($event)" [account]='account' [accountAssessment]='selectedAssessment'></cw-ci-assessment-report>

  <ng-container *ngIf="state=='ERRORSTATE'">
    <cw-dialog [title]='dialogTitle' style="height:470px;">
      <span>{{dialogMessage}}</span>
    </cw-dialog>
  </ng-container>
</div>